var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFioulB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.15 197.172V233.462H130.11C130.11 235.482 128.94 237.472 126.57 239.012C121.87 242.072 114.25 242.072 109.56 239.012C107.22 237.472 106.03 235.472 106.03 233.462V197.172H130.15Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.59 202.722C121.89 205.782 114.27 205.782 109.58 202.722C104.88 199.662 104.88 194.692 109.58 191.612C114.29 188.552 121.91 188.552 126.59 191.612C131.28 194.692 131.28 199.662 126.59 202.722Z",
    fill: "#A7CFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.45 29.0224C82.73 22.2424 93.0199 15.4724 103.3 8.69238L177.55 57.3324C167.27 64.0424 156.98 70.7524 146.7 77.4624C121.95 61.3124 97.2 45.1724 72.45 29.0224Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.7 238.342L72.45 189.922V29.0225L146.7 77.4625V238.342Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.964 91C100.991 102.306 88.2578 127.69 109.964 135.113C129.501 141.795 118.936 109.105 109.964 91Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1298 177.882C97.8298 180.962 101.65 178.472 101.65 172.332C101.65 166.192 97.8298 158.732 93.1298 155.652C88.4198 152.572 84.5999 155.062 84.5999 161.202C84.5999 167.342 88.4198 174.802 93.1298 177.882ZM93.1298 173.983C96.1798 175.983 98.6599 174.373 98.6599 170.383C98.6599 166.993 96.8698 163.003 94.4298 160.663C94.0098 160.253 93.5698 159.883 93.1098 159.583C92.6498 159.283 92.1998 159.063 91.7798 158.933C89.3798 158.133 87.5999 159.803 87.5999 163.183C87.5999 167.153 90.0698 171.983 93.1298 173.983Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4698 160.662V167.642L91.7998 165.912V158.922C92.2198 159.052 92.6698 159.272 93.1298 159.572C93.5898 159.872 94.0498 160.222 94.4698 160.652V160.662Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.18 196.842C126.88 199.922 130.7 197.432 130.7 191.292C130.7 185.152 126.88 177.692 122.18 174.612C117.47 171.532 113.65 174.022 113.65 180.162C113.65 186.302 117.47 193.782 122.18 196.842ZM122.18 192.943C125.23 194.943 127.71 193.333 127.71 189.343C127.71 185.963 125.92 181.943 123.48 179.623C123.06 179.213 122.62 178.843 122.16 178.543C121.7 178.243 121.26 178.023 120.83 177.893C118.43 177.093 116.65 178.763 116.65 182.143C116.65 186.113 119.12 190.953 122.18 192.943Z",
    fill: "#F97E73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.52 179.603V186.593L120.85 184.853V177.873C121.28 178.003 121.72 178.223 122.18 178.523C122.64 178.823 123.08 179.193 123.52 179.603Z",
    fill: "#F97E73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.55 218.233L146.7 238.343V77.4625L177.55 57.3325V218.233Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFioulB);
export default __webpack_public_path__ + "static/media/fioulB.d31c540486fbfefec28290bc89b9cdc4.svg";
export { ForwardRef as ReactComponent };